import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authAction from "@pillvery/redux/auth/actions";
import { Link } from "react-router-dom";
import { routes } from "../../../config/pillveryVariables";
import profileActions from "@pillvery/redux/profile/actions";

const { logout } = authAction;
const { fetchCurrentProfile } = profileActions;
export default function TopbarUser() {
  const dispatch = useDispatch();

  const [user, setUser] = useState();
  const { currentUserProfile, didLoading } = useSelector(
    (state) => state.Profile
  );

  useEffect(() => {
    if (didLoading) {
      if (Object.keys(currentUserProfile).length) {
        setUser(currentUserProfile);
        localStorage.setItem("user", JSON.stringify(currentUserProfile));
      } else {
      }
    }
  }, [didLoading]);
  useEffect(async () => {
    dispatch(fetchCurrentProfile());
  }, []);
  return (
    <li className="nav-item nav-profile dropdown">
      <a
        className="nav-link"
        href="#"
        data-toggle="dropdown"
        id="profileDropdown"
      >
        <img src={user?.profile_image || "/images/picon.jpg"} alt="profile" />
      </a>
      <div
        className="dropdown-menu dropdown-menu-right navbar-dropdown"
        aria-labelledby="profileDropdown"
      >
        <Link
          to={
            user?.role == 1 ? routes.SETTINGS.PROFILE : routes.SETTINGS.GENERAL
          }
          className="dropdown-item"
        >
          <i className="mdi mdi-settings " style={{ color: "#28d2c5" }}></i>
          Settings
        </Link>

        <button className="dropdown-item" onClick={() => dispatch(logout())}>
          <i className="mdi mdi-logout " style={{ color: "#28d2c5" }}></i>
          Logout
        </button>
      </div>
    </li>
  );
}
